import { TextField } from '@fluentui/react';
import React, { useMemo } from 'react';

const ProfileTextField = (props) => {

    // PROPS
    const {
        textFieldProps = {}
    } = props;
    const { disabled, isInvalid } = textFieldProps;

    // MEMOS
    const styles = useMemo(
        () => {
            let styles = {
                root: {
                    fontWeight: 400,
                    fontSize: 14,
                    lineHeight: "18px",
                },
                field: {
                    color: "black",
                    marginBottom: -4,
                    selectors: { "&:disabled": { background: "transparent" } }
                },
                fieldGroup: {
                    background: disabled ? "#FAFAFA" : "white",
                    backgroundColor: isInvalid ? "#FFCCCB" : "white",
                    border: disabled ? "1px solid #DBDBDB !important" : "1px solid black !important",
                    borderRadius: 3,
                    height: 32,
                },
                subComponentStyles: {
                    label: {
                        root: {
                            color: disabled ? "#D9D9D9" : "black",
                            fontWeight: disabled ? 700 : 400,
                            fontSize: 14,
                            lineHeight: "18px",
                            textTransform: "uppercase",
                        }
                    }
                }
            };

            return styles;
        },
        [disabled, isInvalid]
    );

    // RENDER
    return <TextField
        {...textFieldProps}
        placeholder="-"
        styles={styles}
    />;

};

export default ProfileTextField;